import React from 'react';
import PageList from '../../../components/PageListAPI'
import { deleteWorkTemplate, getWorkTemplate } from '../../../api/list'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function WorkTemplate(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='WorkTemplate'
        title='Шаблоны работ для наряд заказа'
        columns={[{ id: 'name', name: 'Название' }]}
        createItem={can(SLUGS.CATALOG.CREATE)}
        deleteItem={can(SLUGS.CATALOG.DELETE)}
        click={can(SLUGS.CATALOG.UPDATE)}
        loadAPI={{
          request: getWorkTemplate,
        }}
        deleteAPI={deleteWorkTemplate}
        {...props}
      />
    </div>
  )
};